import { constantRouterMap } from '@/router/routers'
import Layout from '@/layout/index'

const permission = {
  state: {
    routers: constantRouterMap,
    routerMenuOptions: [],
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
      state.routerMenuOptions = buildRouterMenuOptions(routers)
    }
  },
  actions: {
    GenerateRoutes({ commit }, asyncRouter) {
      return new Promise(resolve => {
        commit('SET_ROUTERS', asyncRouter)
        resolve(flattenRoutes(asyncRouter))
      })
    }
  }
}

/**
 * 将单个路由，假如有三级或三级目录，则转为二级目录格式
 * @param {Object} router 要处理的路由
 * @returns {Object} 处理后的路由
 */
function flattenRouter(router) {
  // 创建一个新的对象来存储转换后的路由
  const newRouter = {
    ...router,
    children: []
  }

  const routerChildren = router.children
  // 从根路由开始扁平化
  if (routerChildren && routerChildren.length > 0) {
    flatten('', routerChildren)
  }

  /**
   * 递归函数来遍历和扁平化路由
   * @param {String} parentPath 父路由路径
   * @param {Array} routes 路由
   */
  function flatten(parentPath, routes) {
    routes.forEach(route => {
      const { path, children } = route
      // 构建完整的路径
      const fullPath = `${parentPath}${path.startsWith('/') ? path.slice(1) : path}`
      // 如果当前路由有子路由，则递归处理
      if (children && children.length > 0) {
        flatten(`${fullPath}/`, children)
      } else {
        // 否则，将当前路由添加到新的children数组中
        newRouter.children.push({
          ...route,
          path: fullPath
        })
      }
    })
  }

  return newRouter
}

/**
 * 处理路由，将三级或三级以上目录的转为二级目录格式
 * @param {Array} routes routes
 * @param {Array} 处理后的路由
 */
export function flattenRoutes(routes) {
  const res = []
  routes.forEach(route => {
    const newRouter = flattenRouter(route)
    res.push(newRouter)
  })
  return res
}

export const filterAsyncRouter = (routers, isTopLevel = true) => { // 遍历后台传来的路由字符串，转换为组件对象
  return routers.filter(router => {
    if (router.component) {
      if (router.component === 'Layout') { // Layout组件特殊处理
        router.component = Layout
      } else {
        const component = router.component
        router.component = loadView(component)
      }
    }
    if (router.children && router.children.length) {
      router.children = filterAsyncRouter(router.children, false)
    } else if (isTopLevel && router.component && router.component !== Layout) {
      // 仅顶层一级菜单：有component但无children，嵌套到Layout中显示菜单栏
      const child = { path: '', component: router.component, meta: router.meta, componentName: router.componentName, name: router.componentName }
      router.component = Layout
      router.children = [child]
    }
		router.name = router.componentName
    return true
  })
}

export const loadView = (view) => {
  return (resolve) => require([`@/views/${view}`], resolve)
}

export const buildRouterMenuOptions = (menus = []) => {
  let options = [];
  for (let item of menus) {
    if (item.meta && item.path && item.path != '/dashboard' && !item.hidden) {
      let option = {
        label: item.meta.title,
        value: item.path,
        name: item.meta.title,
      };
      if (item.children && item.children.length) {
        buildRouterMenuOptions(item.children).forEach((opt) => {
          options.push({
            label: option.label + " > " + opt.label,
            value: option.value + "/" + opt.value,
            name: opt.name ? opt.name : opt.label,
          });
        });
      } else {
        options.push(option);
      }
    }
  }
  return options;
}
export default permission
